export default __webpack_public_path__ + "1065f715ae41fbadb7bd6d9ee880594c.png";